import { render, staticRenderFns } from "./Mymove.vue?vue&type=template&id=4cdcfd11&scoped=true"
import script from "./Mymove.vue?vue&type=script&lang=js"
export * from "./Mymove.vue?vue&type=script&lang=js"
import style0 from "./Mymove.vue?vue&type=style&index=0&id=4cdcfd11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcfd11",
  null
  
)

export default component.exports